import { render, staticRenderFns } from "./PopularizeRecord.vue?vue&type=template&id=633aaebf&scoped=true&"
import script from "./PopularizeRecord.vue?vue&type=script&lang=js&"
export * from "./PopularizeRecord.vue?vue&type=script&lang=js&"
import style0 from "./PopularizeRecord.vue?vue&type=style&index=0&id=633aaebf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633aaebf",
  null
  
)

export default component.exports